export const formatDuration = ({ value, unit }, locale) => {
  if (unit === 'year') {
    return locale === 'fr'
      ? `${value} an${value > 1 ? 's' : ''}`
      : `${value} year${value > 1 ? 's' : ''}`;
  }

  return locale === 'fr'
    ? `${value} mois`
    : `${value} month${value > 1 ? 's' : ''}`;
};

export const formatTotal = (total) => `${String(total).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} F CFA`;
